var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32c-8.823 0-16-7.177-16-16s7.177-16 16-16 16 7.177 16 16-7.177 16-16 16zM16 1.524c-7.985 0-14.476 6.491-14.476 14.476s6.491 14.476 14.476 14.476 14.476-6.491 14.476-14.476-6.491-14.476-14.476-14.476z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.571 20.952c-0.091 0-0.198-0.030-0.274-0.107l-4.297-4.297-4.297 4.297c-0.152 0.152-0.396 0.152-0.533 0s-0.152-0.396 0-0.533l4.297-4.297-4.297-4.297c-0.152-0.152-0.152-0.396 0-0.533s0.396-0.152 0.533 0l4.297 4.297 4.297-4.297c0.152-0.152 0.396-0.152 0.533 0s0.152 0.396 0 0.533l-4.297 4.297 4.297 4.297c0.152 0.152 0.152 0.396 0 0.533-0.076 0.076-0.168 0.107-0.274 0.107z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.f76fb796.svg";
export { ForwardRef as ReactComponent };